<div>
    <div class="ml-3">
        <div [formGroup]="formGroup">

            <div class="row mb-3">
                <div class="col-12">
                    <div class="display-4">
                        Add New Account Information
                    </div>

                    <div class="sub-heading">
                        Create a brand new account
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6 col-12">
                    <div class="row mb-3">
                        <div class="col-4">
                            <label class="required">
                                Company Name
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText (change)="onCompanyNameChange()" maxlength="50" formControlName="companyName" class="w-100" />
                        </div>
                        <div class="offset-4 col-8" style="color: red;" *ngIf="equalCompaniesName">
                            The Company Name is already taken, please enter the new one.
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label class="required">
                                Type
                            </label>
                        </div>

                        <div class="col-8">
                            <p-dropdown autoWidth="false" [style]="{'width':'100%'}" formControlName="companyType" (onChange)="selectedCompanyType($event)" [options]="companyTypes"></p-dropdown>
                        </div>

                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                Industry
                            </label>
                        </div>

                        <div class="col-8">
                            <p-dropdown autoWidth="false" [style]="{'width':'100%'}" formControlName="industry" (onChange)="selectedCompanyType($event)" [options]="industries"></p-dropdown>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                Notification Team
                            </label>
                        </div>

                        <div class="col-8">
                            <p-dropdown autoWidth="false" [style]="{'width':'100%'}" formControlName="notificationGroup" (onChange)="selectedCompanyType($event)" [options]="notificationGroups"></p-dropdown>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                Automatic API build
                            </label>
                        </div>

                        <div class="col-8">
                            <p-inputSwitch formControlName="apiBuild"></p-inputSwitch>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-12">
                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                GCM Advertiser ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText formControlName="GCMAdvertiserId" class="w-100" type="text" (keypress)="onlyNumbers($event)"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                GCM Advertiser Name
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText formControlName="GCMAdvertiserName" class="w-100" type="text"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                TTD Advertiser ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText maxlength="50" formControlName="TTDAdvertiserId" class="w-100" />
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                DV360 Advertiser ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText formControlName="DV360AdvertiserId" class="w-100" type="text" (keypress)="onlyNumbers($event)"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                Meta Ad Account ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText maxlength="30" formControlName="facebookAdAccountId" class="w-100" />
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                Meta Ad Account Name
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText maxlength="100" formControlName="facebookAdAccountName" class="w-100" />
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                Facebook Page ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText maxlength="50" formControlName="facebookPageId" class="w-100" type="text" (keypress)="onlyNumbers($event)"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                Instagram Page ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText maxlength="50" formControlName="instagramId" class="w-100" />
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                Facebook Dataset Pixel ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText formControlName="facebookDatasetPixelId" class="w-100" type="text" (keypress)="onlyNumbers($event)"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                Linkedin Advertiser ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText maxlength="50" formControlName="linkedinAdvertiserId" class="w-100" />
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                TikTok Advertiser ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText maxlength="50" formControlName="tiktokAdvertiserId" class="w-100" />
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                Pinterest Advertiser ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText maxlength="50" formControlName="pinterestAdvertiserId" class="w-100" />
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                Search Ads 360 Client Account ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText maxlength="50" formControlName="searchAds360ClientAccountId" class="w-100" />
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                GAM Advertiser ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText formControlName="gamAdvertiserId" class="w-100" type="text" (keypress)="onlyNumbers($event)"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4">
                            <label>
                                Google Ad Account Customer ID
                            </label>
                        </div>

                        <div class="col-8">
                            <input pInputText maxlength="50" formControlName="googleAdAccountCustomerId" class="w-100" />
                        </div>
                    </div>

                    <div *ngIf="formGroup.get('companyType').value == eAccountType.HMP || currentUser.permissions.isAdmin" class="mb-3">
                        <component-loader-spinner [isLoading]="loading"></component-loader-spinner>
                    
                        <div class="row mb-3 align-items-center" >
                            <div class="col-4 font-weight">
                                DMA
                            </div>
                            <div class="col-8" style="padding-right: inherit;">
                                <p-dropdown [placeholder]="'Choose'" autoWidth="false"  [style]="{'width':'100%'}" formControlName="dma" class="col-7 p-0" [options]="dmas"></p-dropdown>
                            </div>
                        </div>
                        
                        <div class="row mb-3 align-items-center">
                            <div class="col-4 font-weight">
                                City
                            </div>
                            <div class="col-8" style="padding-right: inherit;">
                                <p-multiSelect [placeholder]="'Choose'" autoWidth="false" appendTo="body" [options]="cities" [style]="{'width':'100%'}" formControlName="cities" class="col-7 p-0" [virtualScroll]="true" [itemSize]="30" selectedItemsLabel="{0} items selected"></p-multiSelect>

                            </div>
                        </div>
                        <div class="row mb-3 align-items-center" >
                            <div class="col-4 font-weight">
                                State
                            </div>
                            <div class="col-8" style="padding-right: inherit;">
                                <p-dropdown [placeholder]="'Choose'" autoWidth="false"  [style]="{'width':'100%'}" formControlName="state" class="col-7 p-0" [options]="states"></p-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showNewEdgeUser" class="new-edge-user-section">
     <button type="button" class="remove-edge-user" (click)="removeNewEdgeUser()" title="Remove new EDGE Account User">
        <i class="pi pi-times"></i>
    </button>

    <user-detail #userDetailComponent [formGroup]="formGroupUser" [user]="newUser" [header]="'Account'" [isFromAccount]="true" (onSaveClick)="saveChanges()" [showRolesDropdowns]="newUser"></user-detail>
</div>

<div class="row mx-3 mt-3">
    <div class="col-12 d-flex justify-content-end">
        <button *ngIf="!showNewEdgeUser" type="button" pButton label="New EDGE Account User" class="btn btn-light edge-no-button" (click)="enableNewEdgeUser()"></button>
    </div>
</div>

<div class="row mb-5 mx-3 mt-3">
    <div class="col-12 d-flex justify-content-end">
        <button (click)="onCancel()" class="btn btn-light edge-no-button mr-3">CANCEL</button>

        <button [disabled]="formGroup.invalid || equalCompaniesName || (showNewEdgeUser && (formGroupUser.invalid || userDetailComponent?.equalUserName || userDetailComponent?.equalEmail || !userDetailComponent?.passwordMatch))" [attr.title]="formGroup.invalid || equalCompaniesName || (showNewEdgeUser && (formGroupUser.invalid || userDetailComponent?.equalUserName || userDetailComponent?.equalEmail || !userDetailComponent?.passwordMatch))? 'Please fill in all required fields.':null" (click)="saveChanges()" pButton label="SAVE & EXIT" class="edge-button"></button>
        <!-- 
        <button [disabled]="formGroupUser.invalid || formGroup.invalid" pButton label="SAVE & NEXT" class="p-button-primary"></button> -->
    </div>
</div>